import { useRef, useState } from "react";
import { useFormik } from "formik";
import * as Yup from 'yup';

import api from "src/services/api";

interface ItemsProps {
  DETALHAMENTO: string;
}

interface GroupsProps {
  DESCRICAO_CHECKLISTGRUPO: string;
  LISTAITENS: ItemsProps[];
}

interface ChecklistProps {
  DESCRICAO_CHECKLIST: string;
  ID_CHECKLISTTIPO: string;
  LISTAGRUPOS?: GroupsProps[];
}

export const useCreateChecklist = () => {
  const [groups, setGroups] = useState<GroupsProps[]>([]);
  const [loading, setLoading] = useState(false);

  const toast: any = useRef();

  const validationSchema = Yup.object().shape({
    DESCRICAO_CHECKLIST: Yup.string().required('* O checklist precisa de um título')
  });

  const addNewGroup = () => {
    const groupsCopy = Array.from(groups);
    groupsCopy.push({ DESCRICAO_CHECKLISTGRUPO: '', LISTAITENS: [] });
    setGroups(groupsCopy);
  }

  const updateGroup = ({ target }: any, index: number) => {
    const groupsCopy = Array.from(groups);
    groupsCopy.splice(index, 1, { DESCRICAO_CHECKLISTGRUPO: target.value, LISTAITENS: groupsCopy[index].LISTAITENS });
    setGroups(groupsCopy);
  }

  const deleteGroup = (index: number) => {
    const groupsCopy = Array.from(groups);
    groupsCopy.splice(index, 1);
    setGroups(groupsCopy);
  }

  const addNewItem = (groupIndex: number) => {
    const groupsCopy = Array.from(groups);
    groupsCopy[groupIndex].LISTAITENS.push({ DETALHAMENTO: '' });
    setGroups(groupsCopy);
  }

  const updateItem = ({ target }: any, index: number, groupIndex: number) => {
    const groupsCopy = Array.from(groups);
    groupsCopy[groupIndex].LISTAITENS.splice(index, 1, { DETALHAMENTO: target.value });
    setGroups(groupsCopy);
  }

  const deleteItem = (index: number, groupIndex: number) => {
    const groupsCopy = Array.from(groups);
    groupsCopy[groupIndex].LISTAITENS.splice(index, 1);
    setGroups(groupsCopy);
  }

  const saveChecklist = (values: ChecklistProps) => {
    setLoading(true);
    const groupsCopy = Array.from(groups);

    const newChecklist: ChecklistProps = {
      ...values,
      ID_CHECKLISTTIPO: 'cc08415d-e4bd-49ef-a653-e2fe0d4243a1',
      LISTAGRUPOS: groupsCopy
    }

    api.post('checklist', { CHECKLIST: newChecklist })
      .then((response) => {
        setLoading(false);
        toast.current.show({severity:'success', summary: 'Cadastro realizado', detail:'Checklist criada com sucesso!', life: 5000});
      }).catch((err) => {
        setLoading(false);
        toast.current.show({severity:'error', summary: 'Cadastro não realizado', detail:'Falha ao criar checklist!', life: 5000});
      });
  }

  const formik = useFormik({
    initialValues: {
      DESCRICAO_CHECKLIST: '',
      ID_CHECKLISTTIPO: ''
    },
    onSubmit: (values) => saveChecklist(values),
    validationSchema
  });

  return {
    getChecklist: {
      groups,
      formik,
      loading,
      toast
    },
    handleChecklist: {
      addNewItem,
      updateItem,
      deleteItem,
      addNewGroup,
      updateGroup,
      deleteGroup,
    }
  }
};